import { Directive, Input, inject } from '@angular/core'
import { ElderSelectComponent, Filter, Sort } from '@elderbyte/ngx-starter'
import { FacilityService } from './facility.service'

@Directive({
  selector: '[appFacilitySelect]',
})
export class FacilitySelectDirective {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private select = inject(ElderSelectComponent)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const facilityService = inject(FacilityService)
    this.select.displayProperty = 'name'
    this.select.dataSource = facilityService
    this.select.sorts = [new Sort('code', 'asc')]
  }

  /***************************************************************************
   *                                                                         *
   * Properties                                                              *
   *                                                                         *
   **************************************************************************/
}
